<template>
  <div class="newsfeed">
    <b-carousel animated="slide" :interval="6000" :indicator="false">
      <b-carousel-item v-for="(carousel, i) in newsfeeds" :key="i">
        <section :class="`hero is-small`">
          <div class="newsfeed__item">
            <p class="mb-2 has-text-weight-bold	">
              Congratulations on achieving a new level!
            </p>
            <ProfileCard
              :player="carousel.player"
              :level="carousel.level"
              type="medium"
              color="white"
              :isSquared="true"
              :challenge="true"
            />
            <p class="is-size-7 is-italic">
              {{ carousel.createdAt | distanceFromNow }}
            </p>
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import { firestore } from "@/services/firebase";

export default {
  components: { ProfileCard },

  data() {
    return {
      entries: [],
    };
  },

  computed: {
    newsfeeds() {
      return this.entries.map((entry) => ({
        level: entry.level,
        player: {
          first_name: entry.first_name,
          username: entry.username,
          dna: entry.dna,
          school: { school_name: entry.school_name },
        },
        createdAt: entry.createdAt,
      }));
    },
  },

  firestore: {
    entries: firestore
      .collection("newsfeed")
      .orderBy("createdAt", "desc")
      .limit(24),
  },
};
</script>

<style scoped>
.newsfeed__item {
  align-self: center;
  border: 2px solid #0074dd;
  border-radius: 10px;
  color: white;
  background-color: #0074dd;
  padding: 3px 15px;
  min-width: 350px;
}
</style>
